'use client'

import { animate, motion, useMotionValue, useTransform } from 'framer-motion'
import { useEffect } from 'react'

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver'

export interface AnimatedNumberProps {
  /**
   * Number to be animated
   */
  number: number
  /**
   * Duration of the animation in seconds
   */
  duration?: number
}

export const AnimatedNumber = ({
  number,
  duration = 1.7
}: AnimatedNumberProps) => {
  const { observeElementRef, isIntersecting } =
    useIntersectionObserver<HTMLDivElement>()

  const count = useMotionValue(0)
  const rounded = useTransform(count, latest => Math.round(latest))

  useEffect(() => {
    if (!isIntersecting) return
    const controls = animate(count, number, {
      duration
    })

    return () => controls.stop()
    // Should run only once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting])

  return (
    <motion.div
      data-testid='animated-number'
      ref={observeElementRef}
    >
      {rounded}
    </motion.div>
  )
}
